
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";
import { isEqual } from "lodash";
import { productQueryBuilder } from "@/utils";
import googleAnalyticsEvents from "~/mixins/googleAnalyticsEvents";
import facebookPixelEvents from "~/mixins/facebookPixelEvents";
import useEvents from "~/mixins/useEvents";

export default {
  mixins: [googleAnalyticsEvents, facebookPixelEvents, useEvents],
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState({
      wishlist: (state) => state.wishlist.wishlist,
    }),
    ...mapGetters({
      isWishlistLoaded: "wishlist/getWishListStatus",
    }),
    canSendGoogleAnalyticsStatistic() {
      return this.integrationCallbackStatuses.TYPE_GOOGLE_ANALYTICS && this.isWishlistLoaded;
    },
    canSendFBStatistic() {
      return this.integrationCallbackStatuses.TYPE_FACEBOOK_PIXEL && this.isWishlistLoaded;
    },
  },
  watch: {
    canSendGoogleAnalyticsStatistic: {
      handler(val) {
        if (val) {
          this.gaViewWishlistEvent(this.wishlist);
        }
      },
      immediate: true,
    },
    canSendFBStatistic: {
      handler(val) {
        if (val) {
          this.fbViewWishlistEvent(this.wishlist);
        }
      },
      immediate: true,
    },
  },
  methods: {
    productQueryBuilder,
    ...mapActions({
      setWishlist: "wishlist/setWishlist",
    }),
    async onDelete(item) {
      try {
        const wishlistUniqueId = this.$store.getters.getWishListId;
        const filteredWishlist = this.wishlist.filter(
          (el) =>
            !isEqual(
              { sku: el.sku, engraving: el.engraving },
              { engraving: item.engraving, sku: item.sku }
            )
        );

        const wishlistEventData = {
          product_price: item.price,
          product_title: item.title,
          product_id: item.product_id,
          configuration_id: item.configuration_id,
          product_configuration_id: item.product_configuration_id,
        };
        this.gaRemoveFromWishlistEvent(wishlistEventData);
        this.fbRemoveFromWishlistEvent(wishlistEventData);

        const { data } = await this.$api.wishlist.addItem({
          unique_id: wishlistUniqueId,
          baggage: filteredWishlist,
        });
        this.setWishlist(data.data.baggage);
        this.removeFromFavoritesEvent({
          product_id: item.product_id || "",
          configuration_id: item.configuration_id || "",
          product_sku: item.vendor_model || "",
          product_price: item.price || 0,
          collection_id: item?.collections_ids?.[0] || "",
          product_configuration_id: item.product_configuration_id,
        });
      } catch (err) {
        console.log("err - ", err?.response?.data?.errors);
      }
    },
  },
};
